var React = require('react');

function NewSoundIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M13 14V8.00003","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M9 14V4","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M5 14V10","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

NewSoundIcon.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = NewSoundIcon;

NewSoundIcon.default = NewSoundIcon;
